import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DatosCartowebService } from "../../servicios/datos-cartoweb.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { DatosCartoweb, DatosCartowebInput } from "../../entidades/entidades";


@Component({
    selector: "app-datos-cartoweb",
    templateUrl: "./datos-cartoweb.component.html",
    styleUrls: ["./datos-cartoweb.component.css"]
})

export class DatosCartowebComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    datosCartowebForm: FormGroup;
    @Input("datosCartowebInput") datosCartowebInput: DatosCartowebInput;
    @Output("datosCartowebOutput") datosCartowebOutput$: EventEmitter<DatosCartoweb>;

    existe:boolean = false;

    constructor(
     
        private datosCartowebService: DatosCartowebService,
        private route: ActivatedRoute
    ) {
        this.datosCartowebOutput$ = new EventEmitter()
    }

    ngOnInit() {
        this.getDatosCartoweb()
    }
    ngOnChanges() {
        this.getDatosCartoweb()
    }

    async getDatosCartoweb() {

        //document.forms["formCartoWeb"].submit();
        try {
             const datoRetorno= await this.datosCartowebService
                .getBusquedas(this.datosCartowebInput)
                .toPromise();
                this.datosCartowebOutput$.emit(datoRetorno)
                console.log('CVECATASTRAL: ',datoRetorno.cveCatastral);

                if(datoRetorno.cveCatastral != "")
                {
                    this.existe = true;

                }else if(datoRetorno.cuentaPredial != null)
                {
                    this.existe = true;
                } else
                {
                    this.existe = false;
                }
           
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getDatosCartoweb");
        }
    }


}